/**
 * Generated bundle index. Do not edit.
 */
export { MatSlideToggleModule, MAT_SLIDE_TOGGLE_VALUE_ACCESSOR, MatSlideToggleChange, MatSlideToggleBase, _MatSlideToggleMixinBase, MatSlideToggle } from './public-api';
//# sourceMappingURL=index.js.map